import React from 'react';
import './LoadingOverlay.css';

export default function LoadingOverlay() {
    return (
        <div className="loading-overlay-container">
            <div className="loading-logo-wrapper">
                <img 
                    src="/img/iconb.png" 
                    alt="Logo" 
                />
            </div>
            <div className="spinner-premium"></div>
            <div className="loading-text-premium">CARGANDO...</div>
        </div>
    );
}
